export default __webpack_public_path__ + "static/bg-team-0fa04d672cdcbd01ecd2897b6aa7b364.png";